import { typeCustomType } from "../commerce-custom-type/customType"
import { typeArticleRef } from "./articleRef"
import { typeCommerce } from "./commerce"
import { typeConfiguration } from "./configuration"
import { typeCustomerPrice } from "./customerPrice"
import { typeLocalStrings } from "./localStrings"
import { typeProductRef } from "./productRef"
import { queryCommerce } from "./queries/queryCommerce"
import { queryConfiguration } from "./queries/queryConfiguration"
import { queryLocaleStrings } from "./queries/queryLocaleStrings"
import { resolverCustomerPrice } from "./resolvers/resolverCustomerPrice"
import { typeSort } from "./sort"

const sharedSchema = {
  types: [
    typeArticleRef,
    typeCommerce,
    typeConfiguration,
    typeCustomerPrice,
    typeCustomType,
    typeLocalStrings,
    typeProductRef,
    typeSort,
  ],
  resolvers: {
    Query: { ...queryLocaleStrings, ...queryConfiguration, ...queryCommerce },
    Mutation: {},
    ...resolverCustomerPrice,
  },
}

export default sharedSchema
